var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlPayTvOutlined = function SvgHtlPayTvOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 14H5.5a.5.5 0 0 1 0-1h2v-1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8.5v1h2a.5.5 0 0 1 0 1H8Zm-5-3h10V3H3v8Zm4.529-1v-.382c-.966-.149-1.625-.728-1.625-1.487a.5.5 0 0 1 1 0c0 .252.43.524 1.125.524.695 0 1.125-.327 1.125-.629s-.4-.525-1.195-.638C6.603 7.194 6.12 6.476 6.12 5.87a1.507 1.507 0 0 1 1.41-1.485V4a.5.5 0 0 1 1 0v.386c.377.029.73.196.99.47.187.222.334.44.334.79A.5.5 0 0 1 9 6c-.094-.094-.108-.26-.146-.354-.124-.301-.615-.301-.824-.301-.34 0-.91.068-.91.524 0 .155.261.425.98.528.481.048.946.196 1.367.434a1.363 1.363 0 0 1 .688 1.194A1.74 1.74 0 0 1 8.53 9.613V10a.5.5 0 1 1-1.001 0Z"
  })));
};
export default SvgHtlPayTvOutlined;